<template>
  <kst-section items-mode>
    <kst-table resizable input-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        field="DispatchID"
        :label="InvItemCatalog.DispatchID.ColumnLabel"
      >
        <div class="ks-col-input-grow">
          <kst-output field-only
            :field="column.field" :data="row" :catalog="InvItemCatalog"
          />

          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.Details.getItemInfo(invoiceData, row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </div>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="InvItemCatalog.Packaging.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="RequestedQuantity"
        :label="InvItemCatalog.RequestedQuantity.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="InvItemCatalog.SellPrice.Label"
      >
        <kst-output field-only
          :field="column.field" :data="row" :catalog="InvItemCatalog"
        />
      </b-table-column>

      <template v-if="invoiceData.SpecialPriceCount > 0">
        <b-table-column
          v-slot="{ column, row }"
          cell-class="ks-col-specialpricename"
          field="SpecialPriceID"
          :label="InvItemCatalog.SpecialPriceID.Label"
        >
          <kst-output field-only
            :field="column.field" :data="row" :catalog="InvItemCatalog"
          />
        </b-table-column>
      </template>

      <b-table-column
        v-if="hasItemLevelDisc && hasDiscountedItem"
        v-slot="{ column, row }"
        cell-class="ks-col-disc-value"
        field="DiscPercent"
        label="Diskon"
      >
        <template v-if="row.DiscPercent > 0">
          <kst-output field-only field="DiscPercent" :data="row" :catalog="InvItemCatalog"/>
        </template>
        <template v-else-if="row.DiscValue > 0">
          <kst-output field-only field="DiscValue" :data="row" :catalog="InvItemCatalog"/>
        </template>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="TotalAfterDisc"
        :label="InvItemCatalog.Price.Label"
      >
        <kst-output box-off field-only
          field="TotalAfterDisc" :data="getRowDisplay(row)" :catalog="InvItemCatalog"
        />
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import AppModuleAttr from "../../../services/App/AppModuleAttr.js";
import InvItemCatalog from "../InvItemCatalog.js";
import Model from "../InvModel.js";

export default {
  props: {
    invoiceData: Object,
    items: Array
  },
  data: () => ({
    InvItemCatalog: InvItemCatalog,
    Model: Model
  }),
  computed: {
    hasItemLevelDisc() {
      return this.$kst.Access.hasModuleAttr(AppModuleAttr.ItemLevelDisc_Act_List);
    },
    // tampilkan kolom diskon hanya bila minimal satu baris item berdiskon
    hasDiscountedItem() {
      return Array.isArray(this.items) && this.items.some(
        (row) => (row.DiscPercent || 0) > 0 || (row.DiscValue || 0) > 0
      );
    }
  },
  methods: {
    // Sub Total per baris: pakai TotalAfterDisc jika tersimpan, fallback
    // Price (Qty x Harga) agar tidak kosong untuk baris tanpa diskon item
    // maupun dokumen lama yang belum menyimpan TotalAfterDisc.
    getRowDisplay(row) {
      const totalAfterDisc = row.TotalAfterDisc !== null &&
        row.TotalAfterDisc !== undefined ? row.TotalAfterDisc : null;
      const price = row.Price !== null && row.Price !== undefined
        ? row.Price : null;

      return {
        ...row,
        TotalAfterDisc: totalAfterDisc !== null
          ? totalAfterDisc
          : (price !== null ? price : (row.RequestedQuantity || 0) * (row.SellPrice || 0))
      };
    }
  }
}
</script>